// extracted by mini-css-extract-plugin
export default {"section":"NPATab_section__A57Rp","title":"NPATab_title__AqwG+"};